import { Reducer } from 'react';

import {
  ICatalogPayload, resCatalog, resPagination, resVacancies,
} from '../../utils/types/admin-types';
import {
  Action,
} from '../../utils/types/state-types';
import {
  GET_CATALOG_FILTERS_RECEIVED,
  GET_CATALOG_FILTERS_REJECTED,
  GET_CATALOG_FILTERS_REQUESTED,
} from '../actions/admin-page';

export interface Pagination {
  totalCount: number,
  pages: number
}

const MAIN_FILTERS = ['division', 'group', 'city', 'experience', 'grade'];

export interface CatalogVacancies {
  id: string,
  title: string,
  description: string | null,
  order: number | null,
  hasReward: boolean,
  friendlyUrl: string,
  idForUrl: number,
  city: string | null,
  group: string,
  workExperience: string| null,
  division: string,
  grade: string[] | [],
  role: string | null,
  wf: string[]| []
}

export interface CatalogFilters {
  id: string,
  name: string,
  displayName?: string,
  show: boolean
}

export interface ICatalogReducerState {
  error?: string;
  filters: resCatalog[] | [],
  filtersMain: resCatalog[] | [],
  vacancies: resVacancies | null,
  pagination: resPagination | null,
  isLoading: boolean;
}

const initialState: ICatalogReducerState = {
  filters: [],
  filtersMain: [],
  vacancies: null,
  pagination: null,
  error: '',
  isLoading: false,
};

export const isVacancies = (
  part: unknown,
): part is resVacancies => (part as resVacancies)?.category === 'vacancies';

export const isPagination = (
  part: unknown,
): part is resPagination => (part as resPagination)?.category === 'pagination';

export const isCatalog = (
  part: unknown,
): part is resCatalog => (part as resCatalog)?.category !== 'vacancies'
  && (part as resCatalog)?.category !== 'pagination';

const catalogReducer: Reducer<ICatalogReducerState, Action> = (
  state = initialState,
  action: Action,
) => {
  const { type } = action;
  switch (type) {
    case GET_CATALOG_FILTERS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case GET_CATALOG_FILTERS_RECEIVED: {
      const { payload } = action as Action<ICatalogPayload>;

      const result = {
        filters: payload.result.filter((item) => {
          if (isCatalog(item)) {
            return item.category !== 'vacancies' && item.category !== 'pagination';
          }

          return false;
        }) as resCatalog[],
        filtersMain: (payload.result.filter((item) => {
          if (isCatalog(item)) {
            return MAIN_FILTERS.includes(item.category);
          }
          return false;
        }) as resCatalog[]).sort((a, b) => MAIN_FILTERS.indexOf(a.category) - MAIN_FILTERS.indexOf(b.category)),
        vacancies: payload.result.find((item) => {
          if (isVacancies(item)) {
            return item.category === 'vacancies';
          }

          return false;
        }) as resVacancies,
        pagination: payload.result.find((item) => {
          if (isPagination(item)) {
            return item.category === 'pagination';
          }

          return false;
        }) as resPagination,
      };

      return {
        ...state,
        isLoading: false,
        ...result,
        error: '',
      };
    }
    case GET_CATALOG_FILTERS_REJECTED: {
      const { payload } = action as Action<ICatalogPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    default:
      return state;
  }
};

export default catalogReducer;
